// extracted by mini-css-extract-plugin
export var button = "_1a-1";
export var featuredLink = "_1a-4";
export var spinner = "_1a-2";
export var spinnerContainer = "_1a-3";
export var text = "_1a-0";